import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        ourHotels:"Our Hotels",
        aboutUs:"about",
        
        jumbotronTitle: "Welcome to our hotels",
        jumbotronTitle2: "Experience relaxation and luxury",
        browseMore: "Read more",
        readMore: "Read more",
        aboutHotelsHeader: "About our hotels",
        aboutDescription:
          "Welcome to our wonderful hotel chain, where luxury meets the rich Saudi heritage. We are proud to offer a unique hotel experience in the heart of the Kingdom of Saudi Arabia, where guests can enjoy warm hospitality and excellent service.",
        aboutDescription2:
          "Our hotel chain is characterized by its strategic locations throughout the Kingdom, making it the ideal choice for business travelers and tourists alike. Each hotel in our chain offers a variety of elegantly designed rooms and suites, in addition to a wide range of restaurants and entertainment venues.",
        aboutDescription3:
          "In our hotel chain, we care about the smallest details to ensure your comfort and satisfaction. We look forward to welcoming you to our hotels and showing you what Saudi hospitality truly means.",
        ourHotelsHeader: "We offer our services in a chain of the best hotels",
        ourHotelsLastHotel:
          "Discover luxury at its best with our hotel chain. We offer a unique experience that combines warm hospitality and distinguished service. Whether you are looking for a quiet haven away from the hustle and bustle of everyday life, or a comfortable place for a business trip, our hotel chain provides everything you need.",
        ourHotelsLastHotel2:
          "Our hotels are characterized by their ideal locations in the heart of the city, allowing you to easily access the most prominent tourist landmarks and commercial places. Also, our rooms and suites are carefully designed to provide the highest levels of comfort and luxury.",
        ourHotelsLastHotel3:
          "Join us and enjoy an unforgettable experience, where quality meets hospitality.",
        homeContactusSub: "Let us help you choose a place",
        homeContactusSub2: "for your stay.",
        formName: "Enter your name here",
        formEmail: "Enter your email here",
        formPhone: "Enter your phone number here",
        formMessage: "Enter your message here",

        companyName: "Creators Of Future",
        address: "Saudi Arabia,Jada",
        hotelServicesHeader: "We offer you a range of the best services",
        contactus: "Contact us",
        hotelContactusSub: "And enjoy the best services",
        hotelContactusSub2: "During your visit",
        bookNow: "Book now",
        send:"send"
      },
    },
    ar: {
      translation: {
        ourHotels:"فنادقنا",
        aboutUs:"من نحن",


        jumbotronTitle: "اهلا بك في فنادقنا",
        jumbotronTitle2: "تمتع باجمل اجواء الاسترخاء والرفاهية",
        browseMore: "تصفح المزيد",
        readMore: "اقرأ المزيد ",
        aboutHotelsHeader: "حول فنادقنا",
        aboutDescription:
          " مرحبًا بك في سلسلة فنادقنا الرائعة، حيث الرفاهية تلتقي بالتراث السعودي العريق. نحن نفتخر بتقديم تجربة فندقية فريدة من نوعها في قلب المملكة العربية السعودية، حيث يمكن للضيوف الاستمتاع بالضيافة الحارة والخدمة الممتازة.",
        aboutDescription2:
          " تتميز سلسلة فنادقنا بأنها تقع في مواقع استراتيجية في جميع أنحاء المملكة، مما يجعلها الخيار المثالي للمسافرين من رجال الأعمال والسائحين على حد سواء. كل فندق في سلسلتنا يوفر مجموعة متنوعة من الغرف والأجنحة المصممة بأناقة، بالإضافة إلى مجموعةواسعة من المطاعم والأماكن الترفيهية.",
        aboutDescription3:
          " في سلسلة فنادقنا، نهتم بأدق التفاصيل لضمان راحتك ورضائك. نحن نتطلع إلى الترحيب بك في فنادقنا وإظهار لك ما يعنيه حقًاالضيافة السعودية.",
        ourHotelsHeader: "نقدم خدماتنا في سلسلة من افضل الفنادق",
        ourHotelsLastHotel:
          " اكتشف الرفاهية في أفضل حالاتها مع سلسلة فنادقنا. نحن نقدم تجربة فريدة من نوعها تجمع بين الضيافة الحارة والخدمة المتميزة.سواء كنت تبحث عن ملاذ هادئ بعيدًا عن صخب الحياة اليومية، أو مكان مريح لإقامة رحلة عمل، فإن سلسلة فنادقنا توفر كل ماتحتاجه.",
        ourHotelsLastHotel2:
          " تتميز فنادقنا بأماكنها المثالية في قلب المدينة، مما يتيح لك الوصول بسهولة إلى أبرز المعالم السياحية والأماكن التجارية. كماأن غرفنا وأجنحتنا مصممة بعناية لتوفير أقصى درجات الراحةوالرفاهية.",
        ourHotelsLastHotel3:
          " انضم إلينا واستمتع بتجربة لا تُنسى، حيث الجودة تلتقي بالضيافة.",
        homeContactusSub: "دعنا نساعدك في اختيار مكان",
        homeContactusSub2: "اقامتك.",
        formName: "ادخل اسمك هنا",
        formEmail: "ادخل بريدك الإكتروني هنا",
        formPhone: "ادخل رقم هاتفك هنا",
        formMessage: "ادخل رسالتك هنا",

        companyName: "مبدعو المستقبل للضيافة ",
        address: "المملكة العربية السعودية, جدة",
        hotelServicesHeader: "نقدم لك مجموعة من افضل الخدمات",
        contactus: "تواصل معنا",
        hotelContactusSub: "وتمتع بافضل الخدمات",
        hotelContactusSub2: "خلال زيارتك",
        bookNow: "احجز الان",
        send:"ارسال"
      },
    },
  },
  lng: "ar",
});
